module.exports = __webpack_public_path__ + "img/camera_open.364008a2.png";